import {
  USER_TIMING_TODAY_LIST_FAIL,
  USER_TIMING_TODAY_LIST_REQUEST,
  USER_TIMING_TODAY_LIST_SUCCESS,
  USER_RANGE_DASHBOARD_LIST_FAIL,
  USER_RANGE_DASHBOARD_LIST_REQUEST,
  USER_RANGE_DASHBOARD_LIST_SUCCESS,
  USER_WEEK_DASHBOARD_LIST_FAIL,
  USER_WEEK_DASHBOARD_LIST_REQUEST,
  USER_WEEK_DASHBOARD_LIST_SUCCESS,
} from "../../types/user/TimesTypes";

export const timeDepReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_TIMING_TODAY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_TIMING_TODAY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        UserTimeInfo: payload,
        error: "",
      };
    case USER_TIMING_TODAY_LIST_FAIL:
      return {
        ...state,
        loading: false,
        UserTimeInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const userDepDasboardReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_RANGE_DASHBOARD_LIST_REQUEST:
      return {
        ...state,
        userDashLoading: true,
      };
    case USER_RANGE_DASHBOARD_LIST_SUCCESS:
      return {
        ...state,
        userDashLoading: false,
        userDashList: payload,
        userDashError: "",
      };
    case USER_RANGE_DASHBOARD_LIST_FAIL:
      return {
        ...state,
        userDashLoading: false,
        userDashList: [],
        userDashError: payload,
      };
    default:
      return state;
  }
};

export const userDepWeekReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_WEEK_DASHBOARD_LIST_REQUEST:
      return {
        ...state,
        userDashWeekLoading: true,
      };
    case USER_WEEK_DASHBOARD_LIST_SUCCESS:
      return {
        ...state,
        userDashWeekLoading: false,
        userDashWeekInfo: payload,
        userDashWeekError: "",
      };
    case USER_WEEK_DASHBOARD_LIST_FAIL:
      return {
        ...state,
        userDashWeekLoading: false,
        userDashWeekInfo: [],
        userDashWeekError: payload,
      };
    default:
      return state;
  }
};
